import type { Propose } from "./types";

export const statusLabel = (status: Propose["status"]) =>
  ({
    DRAFT: "下書き",
    INPUTTING: "入力中",
    REVIEW: "確認待ち",
    APPROVED: "承認済み",
    REJECTED: "却下",
    SENT: "送信済み",
  })[status];

export const statusColor = (status: Propose["status"]) =>
  ({
    DRAFT: "default",
    INPUTTING: "blue",
    REVIEW: "gold",
    APPROVED: "green",
    REJECTED: "red",
    SENT: "purple",
  })[status];
